import type { Ref } from '@/composition/vue/compositionApi'
import { TmComponentError } from '@/core/error/TmComponentError'

export const passSlotsThrough = (slots: Record<string, any>) =>
  Object.fromEntries(Object.keys(slots).map((key) => [key, (slotProps: Record<string, any>) => slots[key](slotProps)]))

export const passRefCallback =
  <Component extends Record<string, any>, Method extends keyof Component>(
    componentRef: Ref<Component | undefined>,
    method: Method,
  ) =>
  (...props: Parameters<Component[Method]>) => {
    if (componentRef.value === undefined) {
      throw new TmComponentError('Component ref is undefined')
    }

    if (typeof componentRef.value[method] !== 'function') {
      throw new TmComponentError(`Component's ref ${String(method)} method is undefined`)
    }

    return componentRef.value[method](...props)
  }

export const passRefCallbacks = <Component extends Record<string, any>, Method extends keyof Component>(
  componentRef: Ref<Component | undefined>,
  methods: Method[],
) =>
  Object.fromEntries(
    methods.map((method) => [method, passRefCallback<Component, Method>(componentRef, method)]),
  ) as Pick<Component, Method>
